import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const ScalePriceWithIcon = styled.div`
    display: flex;
    align-items: center;
    gap: ${SPACING.SMALL_2};
`;
